/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searchreadycomplete2Inputs */

const en_searchreadycomplete2 = /** @type {(inputs: Searchreadycomplete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete it`)
};

const de_searchreadycomplete2 = /** @type {(inputs: Searchreadycomplete2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vervollständigen`)
};

/**
* | output |
* | --- |
* | "Complete it" |
*
* @param {Searchreadycomplete2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const searchreadycomplete2 = /** @type {((inputs?: Searchreadycomplete2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searchreadycomplete2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_searchreadycomplete2(inputs)
	return de_searchreadycomplete2(inputs)
});
export { searchreadycomplete2 as "searchReadyComplete" }